import { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router";
import API from "../../common/API";
import { useTranslation } from "react-i18next";
import moment from "moment";

import RecordRelatives from "./RecordRelatives";
import RecordBiometrical from "./RecordBiometrical";
import RecordJudicialRecords from "./RecordJudicialRecords";

import RecordTelefonos from "./RecordTelefonos";
import RecordEstructura from "./RecordEstructura";
import RecordSalarios from "./RecordSalarios";

const RecordContainer = (props: any) => {
    const [generalInfo, setGeneralInfo] = useState<any>();
    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams<{ id: string }>();
    const { t } = useTranslation();
    const bindGeneral = async () => {
        try {
            setIsLoading(true);
            const request = await API.getAction("busqueda/nacionales?cedula=" + id);
            if (request.status === 200) {
                const data = request.data.response;
                if (data && data.length > 0) {
                    setGeneralInfo(data[0]);
                } else {
                    setGeneralInfo(null);
                }
            }
        } catch (error) {
            console.error("Error fetching general data:", error);
        }
        finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        if (id) {
            bindGeneral();
        }
    }, [id])

    if (!generalInfo && isLoading) {
        return <div className="text-center my-4">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>;
    }
    return (
        <Container>
            <Row>
                <Col className="mx-auto"  >
                    {generalInfo &&
                        <Card className="my-4">
                            <Card.Body className="p-4 ">
                                <Row>
                                    <Col xs="auto">
                                        {generalInfo.imagen && (
                                            <img
                                                alt=""
                                                className="card-img-top"

                                                style={{ height: "200px", width: "200px", objectFit: "cover" }}
                                                // style={{ maxHeight: "175px" }}
                                                id="image"
                                                src={"data:image/png;base64," + generalInfo.imagen}
                                            />
                                        )}
                                    </Col>
                                    <Col>
                                        <b className="me-2">{t("Name")}:</b>
                                        {`${generalInfo.nombres ?? ""} ${generalInfo.apellido1 ?? ""
                                            } ${generalInfo.apellido2 ?? ""}`}
                                        <br />
                                        <b className="me-2">Cédula</b>
                                        {generalInfo.cedula}
                                        <br />
                                        <b className="me-2">{t("Fecha de Nacimiento")}</b>
                                        {generalInfo.fechaNacimiento &&
                                            moment(
                                                generalInfo.fechaNacimiento.substring(0, 10)
                                            ).format("DD/MM/YYYY")}
                                        <br />
                                        {generalInfo.alias && <>
                                            <b className="me-2">{t("Alias")}</b>
                                            {generalInfo.alias}
                                            <br />
                                        </>}
                                        <b className="me-2">{t("Género")}</b>
                                        {generalInfo.sexo === "M" ? "Masculino" : "Femenino"}
                                        <br />
                                        <b className="me-2">{t("Edad")}</b>
                                        {generalInfo.edad ? Math.round(generalInfo.edad) : 0}
                                        <br />

                                        <b className="me-2">{t("Lugar de nacimiento")}</b>
                                        {generalInfo.lugarNacimiento}
                                    </Col>
                                    <Col>
                                        <b>RECOMENDACIONES</b><br />
                                        {!generalInfo.fichado && (
                                            <>
                                                <div
                                                    className="badge bg-success text-wrap"
                                                    title={"No antencedentes judiciales"}
                                                >
                                                    <i className="fa fa-check"></i>
                                                    <span className="ms-2">No antencedentes judiciales</span>
                                                </div>
                                                <br />
                                            </>
                                        )}
                                        {generalInfo.extraditado && (
                                            <> <span
                                                className="badge "
                                                style={{ backgroundColor: "blue" }}
                                                title={
                                                    "Solicitar certificado de no extradicción"
                                                }
                                            >
                                                <i className="fa fa-exclamation-triangle me-2"></i>
                                                Solicitar certificado de no extradicción
                                            </span>
                                                <br />
                                            </>
                                        )}
                                        {generalInfo.fichas >= 1 && (<>
                                            <div
                                                className="badge bg-danger  text-wrap"
                                                title={
                                                    "Solicitar certificado de no antecedentes judiciales"
                                                }
                                            >
                                                <i className="fa fa-exclamation-triangle"></i>
                                                <span className="ms-2">
                                                    Solicitar certificado de no antencedentes judiciales
                                                </span>
                                            </div>
                                            <br />
                                        </>
                                        )}
                                        {generalInfo.desaparecido && (
                                            <>
                                                <div
                                                    className="badge bg-warning  text-wrap"
                                                    title={
                                                        "Desaparecid@"
                                                    }
                                                >
                                                    <i className="fa fa-exclamation-triangle"></i>
                                                    <span className="ms-2">
                                                        Desaparecid@
                                                    </span>
                                                </div>
                                                <br />
                                            </>
                                        )}

                                        {generalInfo.deportado && generalInfo.deportado === true && (<><br />
                                            <span
                                                className="badge "
                                                style={{ backgroundColor: "purple" }}
                                                title={
                                                    "Deportado"
                                                }
                                            >
                                                <i className="fa fa-exclamation-triangle me-2"></i>
                                                Solicitar Certificado de no Deportación
                                            </span>
                                            <br />
                                        </>
                                        )}
                                        <div
                                            className="badge bg-warning  text-wrap"
                                            title={"No casos laborales"}
                                        >
                                            <i className="fa fa-check"></i>
                                            <span className="ms-2">No casos laborales</span>
                                        </div>


                                    </Col>
                                </Row>


                            </Card.Body>
                            <Card.Footer className="text-center">
                                <a href={`https://www.google.com/search?q=%22${generalInfo.nombres ?? ""} ${generalInfo.apellido1 ?? ""
                                    } ${generalInfo.apellido2 ?? ""}%22`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm mx-2">
                                    <i className="fa fa-google me-2"></i>
                                    Buscar en Google
                                </a>
                                <a href={`https://www.google.com/search?q=${generalInfo.nombres.split(" ")[0] ?? ""} ${generalInfo.apellido1 ?? ""
                                    } courts usao`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm mx-2">
                                    <i className="fa fa-google me-2"></i>
                                    Buscar en Google <i className="fa fa-plus"></i>
                                </a>
                                <a href={`https://www.google.com/search?q=${generalInfo.nombres ?? ""} ${generalInfo.apellido1 ?? ""
                                    } ${generalInfo.apellido2 ?? ""} site:pgr.gob.do`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm mx-2">
                                    <i className="fa fa-earth-americas me-2"></i>
                                    Justicia
                                </a>
                                <a href={`https://www.google.com/search?q=${generalInfo.nombres.split(" ")[0] ?? ""} ${generalInfo.apellido1 ?? ""
                                    } site:instagram.com`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm">
                                    <i className="fa fa-instagram mx-2"></i>
                                    Buscar en Instagram
                                </a>
                                <a href={`https://www.google.com/search?q=${generalInfo.nombres ?? ""} ${generalInfo.apellido1 ?? ""
                                    } ${generalInfo.apellido2 ?? ""} policianacional.gob.do`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm ms-2">
                                    <i className="fa fa-globe mx-2"></i>
                                    Buscar en Policia
                                </a>


                            </Card.Footer>

                        </Card>
                    }
                    {/* <RecordEmploymentInfo id={id} /> */}
                    <RecordRelatives id={id} />
                    <RecordBiometrical id={id} />
                    <RecordJudicialRecords id={id} />

                    {/* <RecordComplices id={id} /> */}

                    <RecordEstructura id={id} />

                    <RecordSalarios id={id} />
                    <RecordTelefonos id={id} />
                </Col>
            </Row>
        </Container>

    )
}
export default RecordContainer;